import React from 'react';

export default function GhostWispsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="wispGlow1" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%" stopColor="#E1F5FE" stopOpacity="0.85" />
          <stop offset="60%" stopColor="#B3E5FC" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#81D4FA" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="wispGlow2" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#B3E5FC" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* Wisp 1 - large, top */}
      <ellipse cx="12" cy="10" rx="6" ry="7" fill="url(#wispGlow1)" />
      <path d="M9 14 C9 16 10 17 10 18 C11 17 11 18 12 18 C12 17 13 17 14 18 C14 17 15 16 15 14 Z" fill="white" opacity="0.55" />
      {/* Wisp 1 eyes */}
      <ellipse cx="10.5" cy="9" rx="0.8" ry="1.1" fill="#1976D2" opacity="0.6" />
      <ellipse cx="13.5" cy="9" rx="0.8" ry="1.1" fill="#1976D2" opacity="0.6" />
      {/* Wisp 2 - medium, center-right */}
      <ellipse cx="26" cy="18" rx="5" ry="6" fill="url(#wispGlow1)" />
      <path d="M23 22 C23 23 24 24 24 24.5 C25 24 25 24.5 26 24.5 C26 24 27 24 27.5 24.5 C28 24 29 23 29 22 Z" fill="white" opacity="0.55" />
      <ellipse cx="24.8" cy="17.5" rx="0.7" ry="1" fill="#1976D2" opacity="0.6" />
      <ellipse cx="27.2" cy="17.5" rx="0.7" ry="1" fill="#1976D2" opacity="0.6" />
      {/* Wisp 3 - small, bottom-left */}
      <ellipse cx="14" cy="28" rx="4" ry="5" fill="url(#wispGlow1)" />
      <path d="M12 31 C12 32 13 32.5 13 33 C13.5 32.5 14 33 14 33 C14.5 32.5 15 32.5 16 33 C16 32.5 16 32 16 31 Z" fill="white" opacity="0.5" />
      <ellipse cx="13" cy="27.5" rx="0.6" ry="0.9" fill="#1976D2" opacity="0.55" />
      <ellipse cx="15" cy="27.5" rx="0.6" ry="0.9" fill="#1976D2" opacity="0.55" />
      {/* Tiny wisp 4 */}
      <ellipse cx="32" cy="32" rx="3" ry="3.5" fill="url(#wispGlow2)" />
      {/* Subtle floating dots */}
      <circle cx="6" cy="20" r="0.8" fill="white" opacity="0.5" />
      <circle cx="20" cy="34" r="0.6" fill="white" opacity="0.45" />
      <circle cx="34" cy="14" r="0.5" fill="white" opacity="0.5" />
    </svg>
  );
}
